export default "__VITE_ASSET__0891842f__"